// extracted by mini-css-extract-plugin
module.exports = {"container":"FitScreen_container__28MJM","collapse":"FitScreen_collapse__3N5g8"};